"use client";

import NextLink from "next/link";

import type { ComponentProps } from "react";
import { useRouteLanguage } from "./navigation";
import { localizeHref } from "./paths";

export type { LinkProps } from "next/link";

export default function Link({ href, ...props }: ComponentProps<typeof NextLink>) {
  const locale = useRouteLanguage();
  const localized =
    typeof href === "string"
      ? localizeHref(href, locale)
      : href.host || href.hostname || href.protocol
        ? href
        : {
            ...href,
            pathname: href.pathname ? localizeHref(href.pathname, locale) : href.pathname,
          };
  return <NextLink {...props} href={localized} />;
}
